// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const BuyerQueryProvider = registerClientReference(
    function() { throw new Error("Attempted to call BuyerQueryProvider() from the server but BuyerQueryProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(buyer)/providers.tsx <module evaluation>",
    "BuyerQueryProvider",
);
